import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NonceService {
  constructor(private http: HttpClient) {}

  public getNonce(): Observable<string> {
    return this.http.get<string>(`/api/nonce`);
  }
}
